import React, { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import LoginForm from '../../components/Forms/LoginForm/LoginForm';
import useRememberMe from "../../hooks/useRememberMe";
import useSetPageTitle from "../../hooks/useSetPageTitle";
import UserContext from "../../contexts/UserContext";

import {
    validateDocOrEmail,
    validatePassword,
} from '../../validation/index';
import useDataLayer from "hooks/useDataLayer";

function Login() {
    const { setCurrentUser, currentPromo } = useContext(UserContext);
    const navigate = useNavigate();
    const dataLayer = useDataLayer();

    useRememberMe(currentPromo);
    useSetPageTitle('Entrar', currentPromo);

    const [doc, setDoc] = useState('');
    const [docWarning, setDocWarning] = useState('');

    const [password, setPassword] = useState('');
    const [passwordWarning, setPasswordWarning] = useState('');

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleDoc = (inputedDoc) => validateDocOrEmail(inputedDoc, setDoc, setDocWarning);
    const handlePassword = (inputedPassword) => validatePassword(inputedPassword, setPassword, setPasswordWarning);

    const tryLogginIn = (e) => {
        e.preventDefault();
        if (!doc.length) setDocWarning('Este é um campo obrigatório');
        if (!password.length) setPasswordWarning('Este é um campo obrigatório');
        if (!doc.length || docWarning.length || !password.length || passwordWarning.length) {
            return;
        }
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/client/login`, {
                user: doc,
                password: password,
                promo_id: currentPromo.id,
            })
            .then((response) => {
                setLoading(false);
                if (response.status === 200) {
                    setDocWarning('');
                    setPasswordWarning('');
                    setCurrentUser(response.data.client, response.data.accessToken)
                    dataLayer.push({
                        event: 'login-ok',
                    });
                    setErrorMessage('');
                    navigate(`/${currentPromo.path}/home`);
                }
            })
            .catch((err) => {
                setLoading(false);
                if (err.response.status === 404) {
                    dataLayer.push({
                        event: 'error_event',
                        error_code: 404,
                        error_message: 'Elegível não encontrado - 404'
                    });
                    setDocWarning('CPF/CNPJ ou Email não cadastrado');
                    setPasswordWarning('');
                    //setErrorMessage('Elegível não encontrado - 404');
                    return;
                }
                if (err.response.status === 401) {
                    dataLayer.push({
                        event: 'error_event',
                        error_code: 401,
                        error_message: 'Elegível encontrado mas é bloqueado para a promoção atual - 401'
                    });
                    setDocWarning('');
                    setPasswordWarning('Senha incorreta');
                    //setErrorMessage('Elegível encontrado mas é bloqueado para a promoção atual - 401');
                    return;
                }
                if (err.response.status === 400) {
                    dataLayer.push({
                        event: 'error_event',
                        error_code: 400,
                        error_message: 'Elegível já possui cadastro - 400'
                    });
                    setDocWarning('');
                    setPasswordWarning('');
                    //setErrorMessage('Elegível já possui cadastro - 400');
                    return;
                }
            });
    };

    return (
        <div className="login-page-container">
            <LoginForm
                doc={doc}
                setDoc={handleDoc}
                docWarning={docWarning}
                password={password}
                setPassword={handlePassword}
                passwordWarning={passwordWarning}
                onClick={tryLogginIn}
                dontHaveAnAccount={() => navigate(`/${currentPromo.path}/signin`)}
                forgotPassword={() => navigate(`/${currentPromo.path}/esqueci-minha-senha`)}
                loading={loading}
            />
            {errorMessage && (
                <div className="login-form-error-message">
                    <p>{errorMessage}</p>
                </div>
            )}
        </div>
    );
}

export default Login;
